import {Fragment, PureComponent} from 'react'
import {Card, CardBody, CardText} from 'reactstrap'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'

import {generate} from '../../routes.js'

import './OurDifferences.scss'

export default class OurDifferences extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    specificDifference: PropTypes.element.isRequired,
  }

  static defaultProps = {
    className: '',
    specificDifference: null
  }

  render() {
    const cardTexts = [
      <Fragment key="cardTexts-01">
        Des <strong>consultants experts disponibles partout en France</strong> (Paris, Lyon, Nantes, Marseille, Rennes…) — même dans les zones d’emploi en tension.
      </Fragment>,
      <Fragment key="cardTexts-02">
        <strong>Nous privilégions des profils experts et séniors</strong> pour garantir une expertise à haute valeur ajoutée, là où les cabinets s'appuient sur des ressources plus généralistes.
      </Fragment>,
      <Fragment key="cardTexts-03">
        <strong>Une compétence au juste prix</strong> de part la « mise en concurrence » des profils freelances, quand
        les cabinets appliquent une marge subjective fonction des opportunités.
      </Fragment>
    ]

    if (this.props.specificDifference !== null) {
      cardTexts.splice(1, 0, this.props.specificDifference)
    }

    const colWidth = 12 / cardTexts.length

    return (
      <div className={`our-differences ${this.props.className}`}>
        <section className="container text-center py-5">
          <h2 className="mb-5">Pourquoi Twineeds est différent ?</h2>
          <div className="row mb-4">
            {cardTexts.map((cardText, index) => {
              return <div className={`col-md-${colWidth} mb-2`} key={index}>
                <Card className="h-100">
                  <CardBody className="d-flex align-items-center">
                    <CardText>{cardText}</CardText>
                  </CardBody>
                </Card>
              </div>
            })}
          </div>
          <Link className="btn btn-primary" to={generate({name: 'our-vision'})}>En savoir plus</Link>
        </section>
      </div>
    )
  }
}
